import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card p-3 mb-4" }
const _hoisted_2 = { class: "row g-2 align-items-end" }
const _hoisted_3 = { class: "col-md-4 col-sm-6" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "col-md-4 col-sm-6" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "col-md-4 col-sm-6" }
const _hoisted_8 = ["placeholder", "label"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "phone",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('phone'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.phone) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.selectedItems.phone]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "email",
          class: "form-control form-control-sm form-control-solid",
          placeholder: _ctx.translate('email'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.email) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.selectedItems.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-sm form-select-solid",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.areaId) = $event))
        }, [
          _createElementVNode("option", {
            selected: "",
            disabled: "",
            placeholder: _ctx.translate('selectAreas'),
            label: _ctx.translate('selectAreas'),
            value: ""
          }, null, 8, _hoisted_8),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
            return (_openBlock(), _createElementBlock("option", {
              key: area.id,
              value: area.id
            }, _toDisplayString(area.titleAr), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedItems.areaId]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light me-1",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}